import { JsonObject } from "../interface/json";
const d = window as any;

export const scmsService = {
  browse(info: JsonObject) {
    const path = "api/scms/browse";
    return d.$sk.$skxhr(path, info);
  },

  getList(info: JsonObject) {
    const path = "admin/site/data/GetList";
    return d.$sk.$skxhrp(path, info);
  },

  getPageList(info: JsonObject) {
    const path = "admin/page/GetList";
    return d.$sk.$skxhrp(path, info);
  },

  getFile(info: JsonObject) {
    const path = "file/folder/getReleaseFile";
    return d.$sk.$skxhr(path, info);
  },
  getArticle(info: JsonObject) {
    const path = "api/article/get";
    return d.$sk.$skxhr(path, info);
  },
  browseArticle(info: JsonObject) {
    const path = "article/browse";
    return d.$sk.$skxhr(path, info);
  },
  getFileUrl(info) {
    const path = "api/scms/files/GetFileUrl";
    return d.$sk.$skxhr(path, info);
  },
  getFileAuth(info) {
    const path = "api/file/download/auth/get";
    return d.$sk.$skxhr(path, info);
  },
  downloadWithEmail(info) {
    const path = "file/downloadWithEmail";
    return d.$sk.$skxhr(path, info);
  },
  search(info) {
    const path = "api/scms/content/query";
    return d.$sk.$skxhr(path, info);
  },
  //  获取权限菜单
  getMenuList(info) {
    const path = "api/scms/menu/GetList";
    return d.$sk.$skxhr(path, info);
  },
  //   获取页面是否有权限
  getPageAuth(info) {
    const path = "api/scms/menu/Auth";
    return d.$sk.$skxhr(path, info);
  },
  // 收藏文章
  saveCollect(info) {
    const path = "api/collect/Instance";
    return d.$sk.$skxhr(path, info);
  },
  // 获取文章收藏状态
  getCollectStatus(info) {
    const path = "api/collect/GetStatus";
    return d.$sk.$skxhr(path, info);
  },
  // 取消收藏
  delCollect(info) {
    const path = "api/collect/Del";
    return d.$sk.$skxhr(path, info);
  },
  // 获取模版链接
  getTempUrl(info) {
    const path = "api/scms/Get";
    return d.$sk.$skxhr(path, info);
  },
  // 获取公众号id
  getWecaht(info) {
    const path = "api/scms/GetWeChat";
    return d.$sk.$skxhr(path, info);
  },
};
